import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrievePrimaryMenu } from "../../redux/slice/primary-menu-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import DropdownMenu from "./dropdown-menu";

const SecondaryNav = () => {
  const { data } = useSelector((state: RootState) => state.primaryMenu)

  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(retrievePrimaryMenu())
  }, [dispatch])

  const handleClick = (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const dropdown = $(evt.currentTarget).find('.dropdown-menu')
    dropdown.toggle()
    return false;
  }
  const handleTouch = (evt: React.TouchEvent<HTMLDivElement>) => {
    evt.preventDefault();
    const target = $(evt.currentTarget);
    const prop = target.find('.dropdown-menu').css('display');
    const dropdown = target.find('.dropdown-menu')
    target.parent().find('.dropdown-menu').hide();
    if (prop === 'none') dropdown.show()
    if (prop !== 'none') dropdown.hide()
    //dropdown.toggle()
    return false;
  }

  const handleEnter = (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const dropdown = $(evt.currentTarget).find('.dropdown-menu')
    //console.log('enter = ', dropdown.is(':visible'));
    dropdown.show()
    return false;
  }
  const handleLeave = (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const dropdown = $(evt.currentTarget).find('.dropdown-menu')
    dropdown.hide()
    return false;
  }

  if (data) {
    return <>
      <nav className="navbar navbar-expand-lg pb-0">
        <div className="container">
          <div className="navbar-collapse collapse" id="navbarContent">
            <div className="themenu navbar-nav text-center">
              {
                data.map((menuItemdata) => {
                  return menuItemdata.data.map((menuItem, index) => {
                    return menuItem.childrens.map((item, index) => {
                      return <>
                        <div className={`menu-item nav-item dropdown-off position-static topic ${item.name.toLowerCase()}`} key={index} onClick={handleClick} onMouseEnter={handleEnter} onMouseLeave={handleLeave} onTouchEnd={handleTouch} >
                          <span className="menu-title dropdown-toggle-off">
                            <h4 className="title" key={index}>{item.name} <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow"></i></h4>
                          </span>
                          <DropdownMenu links={item.childrens} callout={item} />
                        </div>
                      </>
                    })
                  })
                })
              }
            </div>
          </div>
        </div>
      </nav>
      <style>
        {
          `
    .navbar-nav, .navbar-nav .nav-item { width: 100% }

    .navbar {
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: justify;
        justify-content: space-between;
        /*padding: 0.5rem 1rem;*/
    }

        .navbar > .container,
        .navbar > .container-fluid {
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-pack: justify;
            justify-content: space-between;
        }

    .navbar-brand {
        display: inline-block;
        padding-top: 0.3125rem;
        padding-bottom: 0.3125rem;
        margin-right: 1rem;
        font-size: 1.25rem;
        line-height: inherit;
        white-space: nowrap;
    }

        .navbar-brand:hover,
        .navbar-brand:focus {
            text-decoration: none;
        }

    .navbar-nav {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
    }

        .navbar-nav .nav-link {
            padding-right: 0;
            padding-left: 0;
        }

    .navbar-text {
        display: inline-block;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .navbar-collapse {
        -ms-flex-preferred-size: 100%;
        flex-basis: 100%;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-align: center;
        align-items: center;
    }

    .navbar-toggler {
        padding: 0.25rem 0.75rem;
        font-size: 1.25rem;
        line-height: 1;
        background-color: transparent;
        border: 1px solid transparent;
        border-radius: 0.25rem;
    }

        .navbar-toggler:hover,
        .navbar-toggler:focus {
            text-decoration: none;
        }

        .navbar-toggler:not(:disabled):not(.disabled) {
            cursor: pointer;
        }

    .navbar-toggler-icon {
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
        content: "";
        background: no-repeat center center;
        background-size: 100% 100%;
    }

    @media (max-width: 575.98px) {
        .navbar-expand-sm > .container,
        .navbar-expand-sm > .container-fluid {
            padding-right: 0;
            padding-left: 0;
        }
    }

    @media (min-width: 576px) {
        .navbar-expand-sm {
            -ms-flex-flow: row nowrap;
            flex-flow: row nowrap;
            -ms-flex-pack: start;
            justify-content: flex-start;
        }

            .navbar-expand-sm .navbar-nav {
                -ms-flex-direction: row;
                flex-direction: row;
            }

                .navbar-expand-sm .navbar-nav .dropdown-menu {
                    position: absolute;
                }

                .navbar-expand-sm .navbar-nav .dropdown-menu-right {
                    right: 0;
                    left: auto;
                }

                .navbar-expand-sm .navbar-nav .nav-link {
                    padding-right: 0.5rem;
                    padding-left: 0.5rem;
                }

            .navbar-expand-sm > .container,
            .navbar-expand-sm > .container-fluid {
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }

            .navbar-expand-sm .navbar-collapse {
                display: -ms-flexbox !important;
                display: flex !important;
                -ms-flex-preferred-size: auto;
                flex-basis: auto;
            }

            .navbar-expand-sm .navbar-toggler {
                display: none;
            }

            .navbar-expand-sm .dropup .dropdown-menu {
                top: auto;
                bottom: 100%;
            }
    }

    @media (max-width: 767.98px) {
        .navbar-expand-md > .container,
        .navbar-expand-md > .container-fluid {
            padding-right: 0;
            padding-left: 0;
        }
    }

    @media (min-width: 768px) {
        .navbar-expand-md {
            -ms-flex-flow: row nowrap;
            flex-flow: row nowrap;
            -ms-flex-pack: start;
            justify-content: flex-start;
        }

            .navbar-expand-md .navbar-nav {
                -ms-flex-direction: row;
                flex-direction: row;
            }

                .navbar-expand-md .navbar-nav .dropdown-menu {
                    position: absolute;
                }

                .navbar-expand-md .navbar-nav .dropdown-menu-right {
                    right: 0;
                    left: auto;
                }

                .navbar-expand-md .navbar-nav .nav-link {
                    padding-right: 0.5rem;
                    padding-left: 0.5rem;
                }

            .navbar-expand-md > .container,
            .navbar-expand-md > .container-fluid {
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }

            .navbar-expand-md .navbar-collapse {
                display: -ms-flexbox !important;
                display: flex !important;
                -ms-flex-preferred-size: auto;
                flex-basis: auto;
            }

            .navbar-expand-md .navbar-toggler {
                display: none;
            }

            .navbar-expand-md .dropup .dropdown-menu {
                top: auto;
                bottom: 100%;
            }
    }

    @media (max-width: 991.98px) {
        .navbar-expand-lg > .container,
        .navbar-expand-lg > .container-fluid {
            padding-right: 0;
            padding-left: 0;
        }
    }

    @media (min-width: 992px) {
        .navbar-expand-lg {
            -ms-flex-flow: row nowrap;
            flex-flow: row nowrap;
            -ms-flex-pack: start;
            justify-content: flex-start;
        }

            .navbar-expand-lg .navbar-nav {
                -ms-flex-direction: row;
                flex-direction: row;
            }

                .navbar-expand-lg .navbar-nav .dropdown-menu {
                    position: absolute;
                }

                .navbar-expand-lg .navbar-nav .dropdown-menu-right {
                    right: 0;
                    left: auto;
                }

                .navbar-expand-lg .navbar-nav .nav-link {
                    padding-right: 0.5rem;
                    padding-left: 0.5rem;
                }

            .navbar-expand-lg > .container,
            .navbar-expand-lg > .container-fluid {
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }

            .navbar-expand-lg .navbar-collapse {
                display: -ms-flexbox !important;
                display: flex !important;
                -ms-flex-preferred-size: auto;
                flex-basis: auto;
            }

            .navbar-expand-lg .navbar-toggler {
                display: none;
            }

            .navbar-expand-lg .dropup .dropdown-menu {
                top: auto;
                bottom: 100%;
            }
    }

    @media (max-width: 1199.98px) {
        .navbar-expand-xl > .container,
        .navbar-expand-xl > .container-fluid {
            padding-right: 0;
            padding-left: 0;
        }
    }

    @media (min-width: 1200px) {
        .navbar-expand-xl {
            -ms-flex-flow: row nowrap;
            flex-flow: row nowrap;
            -ms-flex-pack: start;
            justify-content: flex-start;
        }

            .navbar-expand-xl .navbar-nav {
                -ms-flex-direction: row;
                flex-direction: row;
            }

                .navbar-expand-xl .navbar-nav .dropdown-menu {
                    position: absolute;
                }

                .navbar-expand-xl .navbar-nav .dropdown-menu-right {
                    right: 0;
                    left: auto;
                }

                .navbar-expand-xl .navbar-nav .nav-link {
                    padding-right: 0.5rem;
                    padding-left: 0.5rem;
                }

            .navbar-expand-xl > .container,
            .navbar-expand-xl > .container-fluid {
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }

            .navbar-expand-xl .navbar-collapse {
                display: -ms-flexbox !important;
                display: flex !important;
                -ms-flex-preferred-size: auto;
                flex-basis: auto;
            }

            .navbar-expand-xl .navbar-toggler {
                display: none;
            }

            .navbar-expand-xl .dropup .dropdown-menu {
                top: auto;
                bottom: 100%;
            }
    }

    .navbar-expand {
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

        .navbar-expand > .container,
        .navbar-expand > .container-fluid {
            padding-right: 0;
            padding-left: 0;
        }

        .navbar-expand .navbar-nav {
            -ms-flex-direction: row;
            flex-direction: row;
        }

            .navbar-expand .navbar-nav .dropdown-menu {
                position: absolute;
            }

            .navbar-expand .navbar-nav .dropdown-menu-right {
                right: 0;
                left: auto;
            }

            .navbar-expand .navbar-nav .nav-link {
                padding-right: 0.5rem;
                padding-left: 0.5rem;
            }

        .navbar-expand > .container,
        .navbar-expand > .container-fluid {
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
        }

        .navbar-expand .navbar-collapse {
            display: -ms-flexbox !important;
            display: flex !important;
            -ms-flex-preferred-size: auto;
            flex-basis: auto;
        }

        .navbar-expand .navbar-toggler {
            display: none;
        }

        .navbar-expand .dropup .dropdown-menu {
            top: auto;
            bottom: 100%;
        }

      `
        }
      </style>
    </>
  }

  return null;
}

export default SecondaryNav;